// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { ModeType } from 'src/app/enums/mode-type.enum';
import { RegionType } from 'src/app/enums/region-type.enum';

export const environment = {
  configurationData: [],
  mode: ModeType.Staging2,
  production: false,
  Aus: {
    userPoolId: 'ap-southeast-2_6Vv452OQI',
    region: 'ap-southeast-2',
    regionName: 'Australia',
    appClients: [
      {
        id: 'MWl1bTBpbG9sbDlsbzUwbGMwcWI0djhyaXM=',
        urlOmni: 'https://au.pat.identity.cbord.com',
        urlTLMiddleware: 'https://stg.api.au.traylogistics2.cbord.com',
      },
    ],
  },
  US: {
    userPoolId: 'us-east-1_k8qFPPquE',
    region: RegionType.USA,
    regionName: 'United States of America',
    clientId: '4l1ft1maiu1sjh12r62jtadpkg',
    appClients: [
      {
        id: 'NGwxZnQxbWFpdTFzamgxMnI2Mmp0YWRwa2c=',
        urlOmni: 'https://identity.api.pat.cbord.com',
        urlTLMiddleware: 'https://stg.api.traylogistics2.cbord.com',
      },
    ],
  },
  accessKeyId: '',
  secretAccessKey: '',
  parameterSSM: '',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
